import { httpPost, httpGet } from '../../../../utils/api.utils';
import { batch } from "react-redux";
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
    getArticleCatalogueMilestoneDetails,
    setArticleCatalogueError,
    getArticleDetailbyId,
    articleCatalogueMilestoneModel,
    getArticleCatalogueDropdownList,
    resetArticleCatalogueMilestoneForm,
    resetArticleComponentMilestoneForm,
    getCountryCodeList,
    getSalesOrganizationList
} from '../../../../constants/model-reducers/external/recharge/article-catalogue-milestone.settings';

import { actions } from 'react-redux-form';
import { DEFAULT_TABLE_RESULT_ARTICLE_CATALOGUE_DROPDOWN_MODEL, DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../../constants/external-constants';

export const articleCatalogueMilestoneInitialState = articleCatalogueMilestoneModel

const defaultState = () => ({
    isArticleCatalogueLoaded: false,
    isArticleCatalogueError: false,
    articleCatalogueItems: DEFAULT_TABLE_RESULT_MODEL,
    articleCatalogueColSort: '',
    articleCatalogueIsSortedAsc: true,
    isArticleCatalogueDropDownListLoaded: false,
    isFetchFormLoaded: false,
    isNew: true,
    countryCodeList: [],
    salesOrganizationList: [],
    isCountryCodeLoaded: false,
    isSalesOrganizationListLoaded: false,
    articleCatalogueDetails: {
        articleId: 0,
        articleNumber: "",
        articleName: "",
        serviceFamily: "",
        salesOrganizationId: 0,
        salesOrganizationNumber: "",
        salesOrganizationName: "",
        salesOrganizationCountryCode: "",
        countryId: 0,
        countryCode: "",
        priceCalculationId: 0,
        priceCalculation: "",
        vatGroupId: 0,
        preArticleId: "",
        chargeTypeId: 0,
        chargeType: "",
        priceUnit: "",
        chargeCategoryId: 0,
        chargeCategory: "",
        fixedFee: "",
        isAlternateLogic: false,
        additionalAttribute: "",
        articleStatusId: 0,
        articleComponent: [],
        formula: "",
    },
});
const initialState = defaultState();
export const articleCatalogueMilestoneActions = {
    getArticleCatalogueMilestoneDetails: (articleId) => async (dispatch) => {

        var data = await httpGet(`external/recharge/getArticleDetails/${articleId}`);

        if (data) {
            batch(() => {
                dispatch(actions.load('articleCatalogueMilestoneForm.articleId', data.ArticleId));
                dispatch(actions.load('articleCatalogueMilestoneForm.articleNumber', data.ArticleNumber));
                dispatch(actions.load('articleCatalogueMilestoneForm.articleName', data.ArticleName));
                dispatch(actions.load('articleCatalogueMilestoneForm.serviceFamily', data.ServiceFamily));
                dispatch(actions.load('articleCatalogueMilestoneForm.salesOrganizationId', data.SalesOrganizationID));
                dispatch(actions.load('articleCatalogueMilestoneForm.salesOrganizationName', data.SalesOrganizationName));
                dispatch(actions.load('articleCatalogueMilestoneForm.salesOrganizationNumber', data.SalesOrganizationNumber));
                dispatch(actions.load('articleCatalogueMilestoneForm.salesOrganizationCountryCode', data.SalesOrganizationCountryCode));
                dispatch(actions.load('articleCatalogueMilestoneForm.countryId', data.CountryID));
                dispatch(actions.load('articleCatalogueMilestoneForm.countryCode', data.CountryCode));
                dispatch(actions.load('articleCatalogueMilestoneForm.priceCalculationId', data.PriceCalculationID));
                dispatch(actions.load('articleCatalogueMilestoneForm.priceCalculation', data.PriceCalculation));
                dispatch(actions.load('articleCatalogueMilestoneForm.vatGroupId', data.VatGroupID));
                dispatch(actions.load('articleCatalogueMilestoneForm.preArticleId', data.PreArticleID));
                dispatch(actions.load('articleCatalogueMilestoneForm.chargeTypeId', data.ChargeTypeID));
                dispatch(actions.load('articleCatalogueMilestoneForm.chargeType', data.ChargeType));
                dispatch(actions.load('articleCatalogueMilestoneForm.priceUnit', data.PriceUnit));
                dispatch(actions.load('articleCatalogueMilestoneForm.chargeCategoryId', data.ChargeCategoryID));
                dispatch(actions.load('articleCatalogueMilestoneForm.chargeCategory', data.ChargeCategory));
                dispatch(actions.load('articleCatalogueMilestoneForm.fixedFee', (data.FixedFee !== 0 && data.FixedFee !== null) ? data.FixedFee : '0.00'));
                dispatch(actions.load('articleCatalogueMilestoneForm.isAlternateLogic', data.IsAlternateLogic));
                dispatch(actions.load('articleCatalogueMilestoneForm.additionalAttribute', data.AdditionalAttribute));
                dispatch(actions.load('articleCatalogueMilestoneForm.articleStatusId', data.ArticleStatusID));
                dispatch(actions.load('articleCatalogueMilestoneForm.articleComponent', data.ArticleComponent));
                dispatch(actions.load('articleCatalogueMilestoneForm.formula', data.ClientFormula));

                dispatch({ type: getArticleCatalogueMilestoneDetails, data: false });
            });
            return data;
        }
        else {
            dispatch(actions.load("articleCatalogueMilestoneForm", articleCatalogueMilestoneInitialState));
            dispatch(actions.reset('articleCatalogueMilestoneForm'));
        }
    },

    getSalesOrganizationDetails: (salesOrganizationId) => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getSalesOrganizationDetails' + '/' + salesOrganizationId);

        if (res != null) {
            dispatch(actions.change('articleCatalogueMilestoneForm.salesOrganizationName', res.SalesOrganizationName));
        }
        else {
            dispatch({
                type: setArticleCatalogueError,
                isArticleCatalogueError: true
            });
        }
    },

    getArticleCatalogueDropdownList: () => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getArticleCatalogueDropdownList');

        if (res != null) {
            dispatch({
                type: getArticleCatalogueDropdownList,
                isArticleCatalogueDropDownListLoaded: true,
                articleCatalogueDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_ARTICLE_CATALOGUE_DROPDOWN_MODEL,
            });
        }
        else {
            dispatch({
                type: setArticleCatalogueError,
                isArticleCatalogueDropDownListLoaded: false,
                isArticleCatalogueError: true
            });
        }
    },

    getCountryCodeList: (page=1, searchString='') => async (dispatch, getState) => {

        if (getState().isCountryCodeLoaded) return;

        const pageSize = 15;

        dispatch({ 
            type: getCountryCodeList,
            isCountryCodeLoaded: false 
        });
                
        var url = `external/recharge/getArticleCountryCodeList/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getCountryCodeList,
                isCountryCodeLoaded: true,
                countryCodeList: res?.countryCodes?.length > 0 ? res?.countryCodes : [],
                hasMoreData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getCountryCodeList,
                isCountryCodeLoaded: false,
                countryCodeList: [],
                isError: true
            });
        }
    },

     getSalesOrganizationList: (page=1, searchString='') => async (dispatch, getState) => {

        if (getState().isSalesOrganizationListLoaded) return;

        const pageSize = 15;

        dispatch({ 
            type: getSalesOrganizationList,
            isSalesOrganizationListLoaded: false 
        });
                
        var url = `external/recharge/getArticleSalesOrgNumberList/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getSalesOrganizationList,
                isSalesOrganizationListLoaded: true,
                salesOrganizationList: res?.orgNumbers?.length > 0 ? res?.orgNumbers : [],
                hasMoreData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getSalesOrganizationList,
                isSalesOrganizationListLoaded: false,
                salesOrganizationList: [],
                isError: true
            });
        }
    },

    getSelectedCountryCode: (countryCodeId) => async (dispatch) => {
        var res = await httpGet('external/recharge/getSelectedCountryCode' + '/' + countryCodeId);
        return res;
    },

    getSelectedSalesOrg: (salesOrganizationId) => async (dispatch) => {
        var res = await httpGet('external/recharge/getSelectedSalesOrg' + '/' + salesOrganizationId);
        return res;
    },

    saveArticleCatalogueForm: (articleId, validate) => async (dispatch, getState) => {
        try {
            const { articleCatalogueMilestoneForm } = getState().form;
            const {
                articleId,
                articleNumber,
                articleName,
                serviceFamily,
                salesOrganizationId,
                salesOrganizationName,
                salesOrganizationNumber,
                salesOrganizationCountryCode,
                countryId,
                countryCode,
                priceCalculationId,
                priceCalculation,
                vatGroupId,
                preArticleId,
                chargeTypeId,
                chargeType,
                priceUnit,
                chargeCategoryId,
                chargeCategory,
                fixedFee,
                isAlternateLogic,
                additionalAttribute,
                articleStatusId,
                articleComponent,
                formula,
            } = articleCatalogueMilestoneForm;

            const formData = {
                ArticleId: articleId || null,
                ArticleNumber: articleNumber || "",
                ArticleName: articleName || "",
                ServiceFamily: serviceFamily || "",
                SalesOrganizationID: salesOrganizationId && salesOrganizationId !== 0 ? salesOrganizationId : 0,
                SalesOrganizationName: salesOrganizationName || "",
                SalesOrganizationNumber: salesOrganizationNumber || "",
                SalesOrganizationCountryCode: salesOrganizationCountryCode || "",
                CountryID: countryId && countryId !== 0 ? countryId : 0,
                CountryCode: countryCode || "",
                PriceCalculationID: priceCalculationId && priceCalculationId !== 0 ? priceCalculationId : 0,
                PriceCalculation: priceCalculation || "",
                VatGroupID: vatGroupId && vatGroupId !== 0 ? vatGroupId : 0,
                PreArticleID: preArticleId || "",
                ChargeTypeID: chargeTypeId && chargeTypeId !== 0 ? chargeTypeId : 0,
                ChargeType: chargeType || "",
                PriceUnit: priceUnit || "",
                ChargeCategoryID: chargeCategoryId && chargeCategoryId !== 0 ? chargeCategoryId : 0,
                ChargeCategory: chargeCategory || "",
                FixedFee: fixedFee || '0.00',
                IsAlternateLogic: Boolean(isAlternateLogic) || false,
                AdditionalAttribute: additionalAttribute || null,
                ArticleStatusID: articleStatusId && articleStatusId !== 0 ? articleStatusId : 0,
                // Remove Key if ArticleId exists, otherwise keep Key
                ArticleComponent: articleComponent?.map(({ ArticleId, Key, ...rest }) =>
                    ArticleId ? { Key, ...rest } : { Key: 0, ...rest }
                ) || [],
                ClientFormula: formula || null,
            };

            const result = await saveArticleCatalogue(articleId, validate, formData);
            if (result.success && !validate) {
                dispatch(actions.load("articleCatalogueMilestoneForm", articleCatalogueMilestoneForm));
            }

            return result;
        } catch (error) {
            console.error("Error in saveArticleCatalogueForm:", error);
            return { success: false, error };
        }
    },

    resetArticleCatalogueMilestoneForm: () => async (dispatch) => {
        dispatch(actions.reset('articleCatalogueMilestoneForm'));

        dispatch({
            type: resetArticleCatalogueMilestoneForm,
            isFetchFormLoaded: false,
            isArticleCatalogueError: false,
        });
    },

    resetArticleComponentMilestoneForm: () => async (dispatch) => {
        dispatch(actions.reset('articleCatalogueMilestoneForm.articleComponent'));
        dispatch(actions.reset('articleCatalogueMilestoneForm.formula'));
        dispatch({
            type: resetArticleCatalogueMilestoneForm,
            isFetchFormLoaded: false,
            isArticleCatalogueError: false,
        });
    }
};


async function saveArticleCatalogue(articleId, validate, data) {
    try {
        var result = await httpPost(`external/recharge/saveArticleDetails/${articleId ?? 0}/${validate ?? 0}`, data);
        if (result.ok == false) {
            throw {
                success: false,
                message: "Debitor details is not saved. Error encouterd while on saving"
            }
        }
        return result
    }
    catch (e) {
        throw e;
    }
}
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getArticleCatalogueMilestoneDetails: {
            return {
                ...state,
                fetchFormInProgress: action.data
            };
        }
        case getArticleDetailbyId:
            return {
                ...state,
                articleCatalogueDetails: action.articleDetails,
                articleDetails: action.articleDetails,
                isArticleCatalogueError: action.isArticleCatalogueError,
                isFetchFormLoaded: action.isFetchFormLoaded,
            };
        case getArticleCatalogueDropdownList:
            return {
                ...state,
                isArticleCatalogueDropDownListLoaded: action.isArticleCatalogueDropDownListLoaded,
                articleCatalogueDropDownList: action.articleCatalogueDropDownList
            };
        case setArticleCatalogueError:
            return {
                ...state,
                isArticleCatalogueError: action.isArticleCatalogueError,
                isArticleCatalogueLoaded: action.isArticleCatalogueLoaded
            };
        case resetArticleCatalogueMilestoneForm:
            return {
                ...state,
                isFetchFormLoaded: action.isFetchFormLoaded,
                isArticleCatalogueError: action.isArticleCatalogueError
            };
        case resetArticleComponentMilestoneForm:
            return {
                ...state,
                isFetchFormLoaded: action.isFetchFormLoaded,
                isArticleCatalogueError: action.isArticleCatalogueError
            };

         case getCountryCodeList:
            return {
                ...state,
                countryCodeList: action.page === 1? action?.countryCodeList ?? [] : [...state?.countryCodeList, ...action?.countryCodeList ?? []],
                hasMoreCountryCode: action.hasMoreData,
                isCountryCodeLoaded: action.isCountryCodeLoaded,
                countryCodePage: action.page
            }
        case getSalesOrganizationList:
             return {
                ...state,
                salesOrganizationList: action.page === 1? action?.salesOrganizationList ?? [] : [...state?.salesOrganizationList, ...action?.salesOrganizationList ?? []],
                hasMoreSalesOrgList: action.hasMoreData,
                isSalesOrganizationListLoaded: action.isSalesOrganizationListLoaded,
                salesOrganizationPage: action.page
            }
        default:
            return state;
    }
};